import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmployeeTimeOffHomeComponent } from './employee-home/employee-time-off-home.component';
import { EmployeeTimeOffRequestModalComponent } from './employee-time-off-request-modal/employee-time-off-request-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { NgSharedLibraryModule } from '../../ng-shared-library.module';
import { ClientTimeOffHomeComponent } from './client-time-off-home/client-time-off-home.component';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { ClientTimeOffRequestModalComponent } from './client-time-off-request-modal/client-time-off-request-modal.component';
import { ClientNewRequestModalComponent } from './client-new-request-modal/client-new-request-modal.component';
import { EmployeeConditionalApprovalComponent } from './employee-conditional-approval/employee-conditional-approval.component';
import { HoursDisplayComponent } from './hours-display/hours-display.component';
import { EmployeeApprovedRequestModalComponent } from './employee-approved-request-modal/employee-approved-request-modal.component';
import { OpenRequestTableComponent } from './client-time-off-home/open-request-table/open-request-table.component';
import { ApprovedRequestTableComponent } from './client-time-off-home/approved-request-table/approved-request-table.component';
import { ClientEditApprovedComponent } from './client-edit-approved/client-edit-approved.component';
import { EmployeeRequestEditedComponent } from './employee-request-edited-modal/employee-request-edited.component';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';

@NgModule({
  declarations: [
    EmployeeTimeOffHomeComponent,
    EmployeeTimeOffRequestModalComponent,
    ClientTimeOffHomeComponent,
    ClientTimeOffRequestModalComponent,
    ClientNewRequestModalComponent,
    EmployeeConditionalApprovalComponent,
    HoursDisplayComponent,
    EmployeeApprovedRequestModalComponent,
    OpenRequestTableComponent,
    ApprovedRequestTableComponent,
    ClientEditApprovedComponent,
    EmployeeRequestEditedComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgbInputDatepicker,
    NgSharedLibraryModule,
    FormsModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    NgxsFormPluginModule
  ]
})
export class TimeOffModule {}
